(function ($) {
  jQuery(document).ready(function () {
    $(window).scroll(function(){ 
       if ($(this).scrollTop() > 100) { 
            $('#scroll').fadeIn(); 
       } else { 
            $('#scroll').fadeOut(); 
       } 
    }); 
    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 
    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $('.cart-popup__cta-link').on('click', function(e) {
      e.preventDefault();
      $('button.js-close-header-cart').click();
    });
  });    
})(jQuery);